import { get, post } from '../index'
export default{
  // 获取抽奖设置
  getLotterySetting () {
    return get('/integralshop/LotterySetting/get')
  },
  // 抽奖设置
  setLotterySetting (querys) {
    return post('/integralshop/LotterySetting/set',querys)
  },
}



// WEBPACK FOOTER //
// ./src/api/modules/lottery.js